import {
  MLAApplicationComment,
  MLAApplicationStatus
} from '../hooks/useGetMLAApplicationList';

export const lookupValue = <K extends string | number>(
  lookup: Record<K, string>,
  value: K
): string => lookup[value] ?? String(value);

export const EXP_LOOKUP: Record<number, string> = {
  0: '0-1',
  1: '2-3',
  2: '3-5',
  3: '> 5'
};

export const ONE_MONTH_NEW_ACC_LOOKUP: Record<number, string> = {
  0: '0-5',
  1: '5-10',
  2: '10-50',
  3: '> 50'
};

export const PER_MONTH_TRADING_VOLUME_LOOKUP: Record<number, string> = {
  0: ' <50',
  1: '50 - 200',
  2: '200 - 500',
  3: '500 - 1000',
  4: '1000 - 2000',
  5: '> 2000'
};

export const AVG_DEPOSIT_LOOKUP: Record<number, string> = {
  0: '< 2000',
  1: '2001 - 5000',
  2: '5001 - 10000',
  3: '10001 - 20000',
  4: '> 20000'
};

export const REVIEW_STATUS_LOOKUP: Record<MLAApplicationStatus, string> = {
  [MLAApplicationStatus.Pending]: 'pending',
  [MLAApplicationStatus.Approve]: 'approved',
  [MLAApplicationStatus.Reject]: 'reject'
};

export const COMMENT_LOOKUP: Record<MLAApplicationComment, string> = {
  [MLAApplicationComment.None]: 'none',
  [MLAApplicationComment.NotQualified]: 'notQualified',
  [MLAApplicationComment.Duplicated]: 'duplicated'
};

export const SYNC_STATUS_LOOKUP: Record<string, string> = {
  PENDING_SYNC: 'processing',
  SYNCED: 'active',
  SYNC_FAILED: 'createFailed'
};
